import { Container, i18n, Table, TableRow, utils } from "@common";
import { useRef, useCallback, useState, useMemo } from 'react';
import Edit from './edit';
import { AccountStatusOptions, AccountStatuslI18N } from "../constant";
import { adminService } from "@api";
import ProgressBar from "./progressBar";

const columns = [
    { header: i18n.get('CIS_Admin_StudentManagement_StudentID_Entry'), sortable: 1, valuePath: 'studentId' },
    { header: i18n.get('CIS_Admin_StudentManagement_DisplayName_Entry'), sortable: true, valuePath: 'displayName' },
    { header: i18n.get('CIS_Admin_StudentManagement_Email_Entry') },
    { header: i18n.get('CIS_Admin_StudentManagement_AccountStatus_Entry') },
    { header: i18n.get('CIS_Admin_StudentManagement_StatusReason_Entry') },
    { header: i18n.get('CIS_Admin_StudentManagement_LastLogin_Entry'), sortable: true, valuePath: 'lastLogin' },
    { header: i18n.get('CIS_Admin_StudentManagement_IHL_Entry') },
];

const StudentManagement = () => {
    const tableRef = useRef();
    const [showEdit, setShowEdit] = useState({ show: false });
    const [showDialog, setShowDialog] = useState({ show: false });
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemsRassWordOrFA, setSelectedItemsRassWordOrFA] = useState({
        from: null,
        datas: []
    });

    const panelItemRef = useRef();

    const getFilter = useCallback(() => Promise.all([adminService.statusReasonFilter(), adminService.ihlFilter()]).then(
        ([StatusReasonTypeData, GroupsTypeData]) => {
            return {
                StatusReasonType: utils.array.sort(StatusReasonTypeData.StatusReasonType.map(item => {
                    if (item.name === i18n.get('CIS_Admin_Studentmanagement_StatusReason_Old_Entry')) {
                        return { ...item, name: i18n.get('CIS_Admin_Studentmanagement_StatusReason_New_Entry') };
                    }
                    return item;
                }), true, "name"),
                GroupsType: utils.array.sort(GroupsTypeData.GroupsType, true, "name")
            };
        }), []);

    const filter = {
        onLoadData: getFilter,
        items: [
            {
                id: 'filter-student-management-account-status',
                field: 'AccountStatus',
                title: i18n.get('CIS_Admin_StudentManagement_Filter_AccountStatus_Entry'),
                items: utils.array.sort(AccountStatusOptions, true, "name")
            },
            {
                id: 'filter-student-management-statu-reason',
                field: 'StatusReasonType',
                title: i18n.get('CIS_Admin_StudentManagement_Filter_StatusReason_Entry'),
            },
            {
                id: 'filter-student-management-ihl',
                field: 'GroupsType',
                title: i18n.get('CIS_Admin_StudentManagement_Filter_IHL_Entry'),
            },
        ],
        search: { id: 'search-student-management', placeholder: i18n.get('CIS_Admin_StudentManagement_Search_Entry') },
    };

    const reloadTable = useCallback((create, message, status) => {
        create ?
            tableRef.current.loadFirstPage() :
            tableRef.current.loadCurrentPage();
        setShowEdit({ show: false });
        setShowDialog({ show: false });
        setSelectedItemsRassWordOrFA({
            from: null,
            datas: []
        });
        if (message) {
            $$.toast(message, status);
        }
    }, [tableRef]);


    const doShowPanel = useCallback(
        (type, item = {}) => {
            panelItemRef.current = item;
            switch (type) {
                case "edit":
                    setShowEdit({ show: true });
                    break;
            }
        }, [setShowEdit]);

    const onRowEvent = useCallback(args => {
        let rowData = args.rowData;
        switch (args.type) {
            case 'edit':
                doShowPanel('edit', rowData);
                break;
            case 'resetPassword':
                doResetPasswordOrFa([rowData], 'resetPassword');
                break;
            case 'resetFA':
                doResetPasswordOrFa([rowData], 'resetFA');
                break;

        }
    }, [doShowPanel, doResetPasswordOrFa]);

    const onEdit = useCallback((value) => {
        doShowPanel("edit", value === 'view' ? panelItemRef.current : selectedItems[0]);
        return false;
    }, [doShowPanel, selectedItems, panelItemRef]);

    const doResetPasswordOrFa = useCallback((selectedItems, from) => {
        setSelectedItemsRassWordOrFA({
            from,
            datas: selectedItems
        });
        setShowDialog({ show: true });
    }, []);

    const { isEditDisabled, isResetPasswordDisabled, isResetFADisabled } = useMemo(() => {
        const isEditDisabled = selectedItems.length !== 1;
        const isResetPasswordDisabled = selectedItems.length === 0;
        const isResetFADisabled = selectedItems.length === 0;
        return { isEditDisabled, isResetPasswordDisabled, isResetFADisabled };
    }, [selectedItems]);

    const buttons = [
        {
            id: "btn-studentManagement-edit",
            type: 'bald',
            text: i18n.get('Common_Edit_Entry'),
            icon: 'fia-pen-edit',
            disabled: isEditDisabled,
            onClick: onEdit
        },
        {
            id: "btn-studentManagement-resetPassword",
            type: 'bald',
            text: i18n.get('CIS_Admin_StudentManagement_ResetPassword_Entry'),
            icon: 'fia-key',
            disabled: isResetPasswordDisabled,
            onClick: () => doResetPasswordOrFa(selectedItems, 'resetPassword')
        },
        {
            id: "btn-studentManagement-resetFA",
            type: 'bald',
            text: i18n.get('CIS_Admin_StudentManagement_ResetFA_Entry'),
            icon: 'fia-lock',
            disabled: isResetFADisabled,
            onClick: () => doResetPasswordOrFa(selectedItems, 'resetFA')
        },
    ];

    const onLoadData = useCallback((info) => {
        return adminService.studentManagementPaging(info);
    }, []);

    const onCheck = useCallback(selectedItems => {
        setSelectedItems(selectedItems);
    }, [setSelectedItems]);


    return (
        <Container>
            <Table
                id="table-student-management"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                buttons={buttons}
                filter={filter}
                checkable
                onCheck={onCheck}
                onRowEvent={onRowEvent}
                sort={{ name: "studentId", status: "asc" }}
            />
            <Edit status={showEdit} item={panelItemRef.current} reloadTable={reloadTable} />
            <ProgressBar status={showDialog} items={selectedItemsRassWordOrFA} reloadTable={reloadTable} />
        </Container>
    );
};
class TableRowTemp extends TableRow {
    editClick = () => this.dispatch('edit');
    resetPassword = () => this.dispatch('resetPassword');
    resetFA = () => this.dispatch('resetFA');

    action = () => {
        return [
            { text: i18n.get('Common_Edit_Entry'), name: 'edit', tooltip: i18n.get('Common_Edit_Entry'), onClick: this.editClick },
            { text: i18n.get('CIS_Admin_StudentManagement_ResetPassword_Entry'), name: 'resetPassword', tooltip: i18n.get('CIS_Admin_StudentManagement_ResetPassword_Entry'), onClick: this.resetPassword },
            { text: i18n.get('CIS_Admin_StudentManagement_ResetFA_Entry'), name: 'resetFA', tooltip: i18n.get('CIS_Admin_StudentManagement_ResetFA_Entry'), onClick: this.resetFA },
        ];
    };
    render(Row, Cell) {
        let { studentId, displayName, email, accountStatus, lastLogin, statusReason, ihl } = this.props.rowData;

        return (
            <Row action={this.action}>
                <Cell>{studentId || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{displayName || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{email || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{accountStatus ? AccountStatuslI18N[accountStatus] : i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{(statusReason === i18n.get('CIS_Admin_Studentmanagement_StatusReason_Old_Entry') ? i18n.get('CIS_Admin_Studentmanagement_StatusReason_New_Entry') : statusReason) || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{lastLogin ? utils.formatDateTime(lastLogin, true) : i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{ihl || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default StudentManagement;